import React from "react";
import { cn } from "./utils";

const Progress = ({ value = 0, className = "" }) => {
  return (
    <div className={cn("w-full h-2 bg-gray-200 rounded-full", className)}>
      <div
        className="h-full bg-blue-600 rounded-full transition-all"
        style={{ width: `${value}%` }}
      />
    </div>
  );
};

export { Progress };
